import { render, staticRenderFns } from "./WorkingAreaItem.vue?vue&type=template&id=e66162a8"
import script from "./WorkingAreaItem.vue?vue&type=script&lang=js"
export * from "./WorkingAreaItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports